<template>
  <b-modal
    class="warning-modal d-flex flex-column justify-content-center"
    v-model="showModal"
    size="md"
    @hidden="isHidden"
    centered
    hide-footer
    hide-header
  >
    <div class="text-center">
      <img
        src="@/assets/images/common/drip-symbol-logo.svg"
        class="m-auto"
        width="24"
        height="24"
      />
    </div>
    <div class="spacing-4"></div>
    <div class="drip-h4 font-weight-700 color-noble-blue-500 text-center">
      {{ $t('legal.banner.title') }}
    </div>
    <div
      class="drip-body-small font-weight-400 color-noble-blue-500 text-center"
    >
      {{ $t('legal.banner.description') }}
    </div>
    <div class="spacing-16"></div>
    <div class="drip-body font-weight-700 color-noble-blue-500">
      {{ $t('legal.banner.stepTitle') }}
    </div>
    <div class="spacing-4"></div>
    <div>
      <ul class="m-0">
        <li class="drip-label font-weight-400">
          {{ $t('legal.banner.instruction') }}
          <a
            id="legal-get-in-touch"
            href="https://dripcapital.com/en-in/contact#get-in-touch"
            target="_blank"
            v-track-click
            class="underline-on-hover"
          >
            {{ $t('legal.banner.clickHere') }}
          </a>
          {{ $t('legal.banner.address') }}
        </li>
        <li class="drip-label font-weight-400">
          {{ $t('legal.banner.bottomText') }}
        </li>
      </ul>
    </div>
    <div class="spacing-12"></div>
    <div class="drip-body-small font-weight-700 color-noble-blue-500">
      {{ $t('legal.banner.note') }}
    </div>
    <div class="spacing-24"></div>
    <div class="text-center">
      <action-button
        variant="solid"
        extraClass="button-style"
        :click="closeDialog"
      >
        {{ $t('legal.banner.getStarted') }}
      </action-button>
    </div>
  </b-modal>
</template>
<script>
import ActionButton from '@/components/common/ActionButton'

export default {
  name: 'LegalWelcomeBanner',
  props: ['showLegalEsignBanner', 'closeModalFn'],
  components: { ActionButton },
  data() {
    return {
      showModal: false
    }
  },
  mounted() {
    if (this.showLegalEsignBanner) {
      this.showModal = this.showLegalEsignBanner
    }
  },
  methods: {
    isHidden() {
      this.$router.push({ path: '/' })
      this.closeModalFn()
    },
    closeDialog() {
      this.$mpTrack('Legal Signing - Get started CTA')
      this.showModal = false
    }
  }
}
</script>
<style lang="scss">
.modal-content {
  border: 0px;
}
.modal-body {
  padding: 24px;
}
</style>
<style lang="scss" scoped>
.button-style {
  margin: auto;
  width: 300px;
}
</style>
